module.exports = __webpack_public_path__ + "img/图片6.17a3135a.png";